import { render } from "./SavingDialog.vue?vue&type=template&id=7346736a&scoped=true"
import script from "./SavingDialog.vue?vue&type=script&lang=js"
export * from "./SavingDialog.vue?vue&type=script&lang=js"

import "./SavingDialog.vue?vue&type=style&index=0&id=7346736a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7346736a"]])

export default __exports__